// extracted by mini-css-extract-plugin
module.exports = {"btnWidth":"btnWidth___2XbfD"};